var map = {
	"./alert-triangle.icon.svg": 1743,
	"./arrow-left.icon.svg": 1744,
	"./bang.icon.svg": 1745,
	"./calendar.icon.svg": 1746,
	"./check.icon.svg": 1747,
	"./chevron-down.icon.svg": 1748,
	"./chevron-left.icon.svg": 1749,
	"./chevron-right.icon.svg": 1750,
	"./chevron-up.icon.svg": 1751,
	"./cross.icon.svg": 1752,
	"./email-alert.icon.svg": 1753,
	"./envelope.icon.svg": 1754,
	"./excel.icon.svg": 1755,
	"./invisible.icon.svg": 1756,
	"./pdf.icon.svg": 1757,
	"./pencil.icon.svg": 1758,
	"./plus.icon.svg": 1759,
	"./refresh.icon.svg": 1760,
	"./search.icon.svg": 1761,
	"./star.icon.svg": 1762,
	"./thumbs-up.icon.svg": 1763,
	"./visible.icon.svg": 1764
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1742;


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/icons nonrecursive ./node_modules/babel-loader/lib?compact=true!./node_modules/react-svg-loader/lib/loader.js?jsx=true \.svg$
// module id = 1742
// module chunks = 0